import httpClient from '@/remoteApi/httpClient';
import { RemoteUser } from '@/remoteApi/UserApi';
import { AppPaths } from '@/configs/appPaths';
import { getFullPathUrl } from '@/utilities';

export interface LoginRequest {
	email: string;
	password: string;
}

export interface LoginResponse {
	accessToken: string;
	refreshToken: string;
}

export interface RegisterRequest extends LoginRequest {
	name: string;
	surname: string;
	companyName: string;
	country: string;
	email: string;
	password: string;
}

type RegisterCheckResponse = { status: boolean };

export interface ResetPasswordRequest {
	hash: string;
	password: string;
}

class AuthApi {
	async login(data: LoginRequest) {
		const response = await httpClient.post<LoginResponse>('auth/login', data);
		return response.data;
	}

	async refreshToken(data: Pick<LoginResponse, 'refreshToken'>) {
		const response = await httpClient.post<LoginResponse>('auth/refresh', data);
		return response.data;
	}

	async register(data: RegisterRequest) {
		const response = await httpClient.post<RemoteUser>('auth/register', data);
		return response.data;
	}

	async registerCheck(data: Pick<LoginRequest, 'email'>) {
		const response = await httpClient.post<RegisterCheckResponse>(
			'auth/register-check',
			data
		);
		return response.data;
	}

	async resetPassword(email: string) {
		const response = await httpClient.post('auth/reset_password/create', {
			email,
			redirectUrl: getFullPathUrl(AppPaths.PASSWORD_CHANGE),
		});
		return response.data;
	}

	async changePassword(data: ResetPasswordRequest) {
		const response = await httpClient.post('auth/reset_password/process', data);
		return response.data;
	}

	async verifyEmail(token: string) {
		const response = await httpClient.post<{ status: boolean }>(
			'users/verify',
			{ token }
		);
		return response.data;
	}
}

export default new AuthApi();
